export default __webpack_public_path__ + "static/media/eevee-letsgo.e951ab9f.webp";